import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';

import { WelcomePath } from './welcome.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWelcomePaths: builder.query<ApiResponse<WelcomePath[]>, { skipRedirect?: boolean }>({
      query: ({ skipRedirect = false }) => {
        const params = new URLSearchParams();
        if (skipRedirect) {
          params.append('skip_redirect', 'true');
        }
        return {
          url: `/paths/welcome`,
          params: skipRedirect ? params : undefined,
        };
      },
    }),
  }),
});

export const { useGetWelcomePathsQuery } = extendedApiSlice;
